import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily, weight } from "@clockwise/web-commons/src/styles/type.styles";

export const container: CSSProperties = {
  border: 1,
  borderStyle: "solid",
  borderColor: greys.borderGrey,
  borderRadius: 10,
  minHeight: 180,
};

export const header = {
  container: {
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  } as CSSProperties,
  icon: {
    fontSize: 18,
    marginRight: 9,
    flexGrow: 0,
  } as CSSProperties,
  title: {
    fontFamily,
    color: colors.blueDusk.standard,
    fontSize: 14,
    fontWeight: weight.bold,
    flexGrow: 1,
  } as CSSProperties,
  toggle: {
    width: "fit-content",
    flexGrow: 0,
  } as CSSProperties,
};

export const meeting: CSSProperties = {
  padding: "9px 15px",
  display: "block",
};

export const scheduledAgo: CSSProperties = {
  fontSize: 12,
  fontWeight: 300,
  color: greys.slate,
  paddingBottom: 12,
};

export const recurrence = {
  container: {
    display: "flex",
    alignItems: "center",
    color: colors.green.standard,
  } as CSSProperties,
};

export const advancedOptions = {
  container: {
    display: "flex",
    alignItems: "center",
    color: greys.blueGrey,
    fontSize: 12,
    cursor: "pointer",
  } as CSSProperties,
  settings: {
    htmlColor: greys.blueGrey,
    style: {
      width: 17,
      height: 17,
      marginRight: 13,
    } as CSSProperties,
  },
  showLess: {
    color: greys.blueGrey,
    fill: greys.blueGrey,
    transition: "transform 0.4s",
  } as CSSProperties,
  showMore: {
    color: greys.blueGrey,
    fill: greys.blueGrey,
    transform: "rotate(180deg)",
    transition: "transform 0.4s",
  } as CSSProperties,
  expanded: {
    paddingTop: 5,
    transition: "all .35s",
    WebkitFontSmoothing: "antialiased",
  } as CSSProperties,
  collapsed: {
    visibility: "hidden",
    opacity: 0,
    height: 0,
    overflow: "hidden",
    transition: "all .35s",
  } as CSSProperties,
};
